// extracted by mini-css-extract-plugin
module.exports = {"Categories":"Categories_Categories__2Rtno"};